export const NAV_LINKS = [
  { to: '/mes', label: 'ОИС' },
  { to: '/documents', label: 'Документы' },
  { to: '/technique', label: 'Техника' },
  { to: '/drivers', label: 'Водители' },
];

export const REPORT_OPTIONS = [
  { value: '', label: 'Отчёты', disabled: true },
  { value: 'materialReport', label: 'Материальный отчет' },
  { value: 'fuelReport', label: 'Топливный отчет' },
];
